import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { publicPageUrl } from '../utils/publicPages';

export default function StaticPageRedirect({ page }) {
  const { i18n } = useTranslation();
  const target = publicPageUrl(i18n.language, page);
  useEffect(() => { window.location.replace(target); }, [target]);
  return <a href={target}>{i18n.language?.startsWith('de') ? 'Seite öffnen' : 'Open page'}</a>;
}
